import { render, staticRenderFns } from "./addVariation.vue?vue&type=template&id=5e1fd414"
import script from "./addVariation.vue?vue&type=script&lang=js"
export * from "./addVariation.vue?vue&type=script&lang=js"
import style0 from "./addVariation.vue?vue&type=style&index=0&id=5e1fd414&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports